// index.js
import './appInsights';          // first import: initializes SDK before MSAL
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authconfig';
import AppErrorBoundary from './components/AppErrorBoundary';

const pca = new PublicClientApplication(msalConfig);

pca.initialize().then(() => {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <MsalProvider instance={pca}>
          <App />
        </MsalProvider>
      </AppErrorBoundary>
    </React.StrictMode>
  );
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
